import AppSettings from '../entity/AppSettings';
import parseJsonAttribute from './parseJsonAttribute';

export default class AppSettingsProvider {
    constructor(element = document.documentElement) {
        this.appSettings = parseJsonAttribute(
            element,
            'data-app-settings',
            {},
            error => console.error('Failed to parse data-app-settings', error),
        );
    }

    getAppSettings() {
        return new AppSettings(
            this.appSettings.google_analytics_tracking_id,
            this.appSettings.google_places_api_key,
            this.appSettings.sentry_js_dsn,
            this.appSettings.poxa_public_host,
            this.appSettings.poxa_port,
            this.appSettings.internal_domain,
        );
    }
}
